var map = {
	"./about1.png": 82,
	"./about__experience.png": 83,
	"./about__persone.jpg": 84,
	"./benefit__point.png": 27,
	"./driver.png": 85,
	"./ferrari__black-gold.jpg": 86,
	"./ferrari__black-red.jpg": 87,
	"./ferrari__black-white.jpg": 88,
	"./ferrari__black.jpg": 89,
	"./ferrari__red-black.jpg": 90,
	"./header__image.jpg": 52,
	"./laferrari__personalized.png": 91,
	"./paint-swatch__black.png": 92,
	"./paint-swatch__red.png": 93,
	"./paint-swatch__white.png": 94,
	"./stalion__badge.svg": 51,
	"./stalion__logo.svg": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;